var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "76px",
    height: "50px",
    viewBox: "0 0 76 50",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.867
    },
    fill: "#fefffe",
    d: "M -0.5,-0.5 C 1.5,-0.5 3.5,-0.5 5.5,-0.5C 5.90814,0.643141 6.57481,1.64314 7.5,2.5C 17.5,8.5 27.5,14.5 37.5,20.5C 38.8761,21.8419 40.2094,23.1752 41.5,24.5C 40.2094,25.8248 38.8761,27.1581 37.5,28.5C 27.5,34.5 17.5,40.5 7.5,46.5C 6.57481,47.3569 5.90814,48.3569 5.5,49.5C 3.5,49.5 1.5,49.5 -0.5,49.5C -0.5,32.8333 -0.5,16.1667 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 44.5,0.5 C 48.5,0.5 52.5,0.5 56.5,0.5C 56.5,16.5 56.5,32.5 56.5,48.5C 52.5,48.5 48.5,48.5 44.5,48.5C 44.5,32.5 44.5,16.5 44.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 62.5,0.5 C 66.5,0.5 70.5,0.5 74.5,0.5C 74.5,16.5 74.5,32.5 74.5,48.5C 70.5,48.5 66.5,48.5 62.5,48.5C 62.5,32.5 62.5,16.5 62.5,0.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayPause);
export default __webpack_public_path__ + "static/media/PlayPause.70add616a0b4ed7739b0ab61e694b192.svg";
export { ForwardRef as ReactComponent };